const lang = require(`@/lang/${selected_lang}/auth.js`);

let forms = {
   login: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'email', class: 'custom-input col-12', model: 'email',
            validation: 'required|min:3|max:150|email', label: lang.model.email
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'password',
            validation: 'required|min:3|max:150', label: lang.model.password
         },
      ],
   },
   verifyRegistrationToken: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'password',
            validation: 'required|min:3|max:150', label: lang.model.password
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'confirm_password',
            validation: 'required|min:3|max:150', label: lang.model.confirm_pass
         },
      ],
   },
   forgot_password: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'email', class: 'custom-input col-12', model: 'email',
            validation: 'required|min:3|max:150|email', label: lang.model.email
         },
      ],
   },
   validate_otp: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'big-input col-12', model: 'otp',
            validation: 'required|min:6|max:6|numeric', label: lang.model.otp
         },
      ],
   },
   reset_password: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'password',
            validation: 'required|min:3|max:150', label: lang.model.password
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'confirmPassword',
            validation: 'required|min:3|max:150', label: lang.model.confirm_pass
         },
      ],
   },
}

module.exports = {
   forms: utils.generateAllFormData(forms),
   lang: lang.view
}